<!-- Media editor page header (Phase 3 editor template). The Sharing field
     moved into the Media Details card (ImageOrVideoEditor.vue). -->
<template>
  <header class="pe-header">
    <div class="pe-header__left">
      <div class="pe-header__title-row">
        <h1 class="bui-page-title">Media Editor</h1>
        <button
          type="button"
          class="pe-header__refresh"
          aria-label="Reload media item"
          data-testid="media-refresh"
          :disabled="isLoading || isReloading"
          @click="reloadMediaItem()"
        >
          <PhArrowsClockwise :size="22" weight="bold" />
        </button>
      </div>
      <div class="pe-header__subtitle">{{ data.name }}</div>
    </div>
  </header>
</template>

<script lang="ts" setup>
import { PhArrowsClockwise } from '@phosphor-icons/vue';
import useMediaItem from '../../composables/mediaItem';
import useImageOrVideo from '../composables/imageOrVideo';

defineProps<{
  isReadOnly: boolean
}>();

const { isLoading, isReloading, reloadMediaItem } = useMediaItem();
const { data } = useImageOrVideo();
</script>

<style lang="scss" scoped>
@import '@/assets/styles/bui-editor-template';
</style>
